import { ThemedView } from '../../theme';
import Typography from '../../sharedComponents/typography/Typography';
import {FontFamilyTokens, FontSizeTokens } from '@voltmoney/schema';
import { BASE_IMAGE_URL } from '../../configs/constants';
import ZeroState from './ZeroState';


export const TRANSACTION_SCREEN = BASE_IMAGE_URL +
  'Empty_Trans.png';


function TransactionScreen() {
  return (
    <ThemedView flex={1} bg='bg-surface-primary'>
      <ThemedView mb='3xl' padding='lg' pt='xl' borderBottomWidth={1} borderBottomColor='border-secondary'>
        <Typography
          label={'Transactions'}
          fontFamily={FontFamilyTokens.Poppins}
          fontSize={FontSizeTokens.MD}
          fontWeight='600'
          lineHeight={24}
        />
      </ThemedView>
      <ZeroState />
    </ThemedView>
  );
}

export default TransactionScreen;
